import { useState, useEffect } from 'react'
import './enrollmentForm.scss'
import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik'
import Button from '../../../components/button/Button'
import NewInput from '../../../components/input/NewInput'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import * as Yup from 'yup'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Calendar from '../../../components/calendar/Calendar'
import { months, paymentMode, ROUTES_PATH, UI_CONSTANT } from '../../../utility/constants'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import {
  convertDateFormatCalendar,
  generateDropdownOptions,
  handleEmail,
  handleInput,
  handleInputAddress,
  handleInputString,
  handleInputStringWithNum,
  handleName,
  handlePassword,
  handlePercentageInput,
} from '../../../utility/genricFunction'
import deleteIcon from '../../../assets/icons/deleteFill.svg'
import { useDispatch, useSelector } from 'react-redux'
import {
  createEnrollment,
  editStudentEnrollmentData,
  getBranchList,
} from '../../../store/builders/enrollment/enrollment.builder'
import { getBatchList, getCourse } from '../../../store/builders/course/course.builder'
import dayjs from 'dayjs'
import apiClient from '../../../services/axois'
import { API_ROUTES } from '../../../utility/api.routes'
import { setCourseFeesStructData } from '../../../store/slice/enrollment/enrollment.slice'
import { VALIDATION_MESSAGES } from '../../../utility/constantValidationMessages'
import { getBranchListData } from '../../../store/builders/branch/branch.builder'
import Loader from '../../../components/loader/Loader'
import {
  getAreaByCityId,
  getCityByStateId,
  getTempAreaByCityId,
  getTempCityByStateId,
} from '../../../store/builders/masterDataSet/masterDataSet.builder'
import { toast, ToastContainer } from 'react-toastify'

function EnrollmentForm() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id } = useParams()
  const location = useLocation()
  const [isSameAddress, setIsSameAddress] = useState(false)
  const [state, setState] = useState()
  const [enroll, setEnroll] = useState()
  const [initialValues, setInitialValues] = useState({
    enrollmentDate: dayjs(Date.now()),
    fatherName: '',
    motherName: '',
    parentPhone: '',
    studentCode: '',
    permanentAddress: '',
    permanentArea: '',
    permanentCity: '',
    permanentState: '',
    temporaryAddress: '',
    temporaryArea: '',
    temporaryState: '',
    temporaryCity: '',
    studentName: '',
    studentEmail: '',
    studentPassword: '',
    studentPhone: '',
    studentBirthDate: '',
    studentStatus: 'active',
    academics: [
      {
        StudentAcademicsDegree: 'H.S.C',
        studentAcademicInstitution: '',
        studentAcademicStream: '',
        studentAcademicCompletionYear: '',
        studentAcademicPercentage: '',
      },
      {
        StudentAcademicsDegree: 'S.S.C',
        studentAcademicInstitution: '',
        studentAcademicStream: '',
        studentAcademicCompletionYear: '',
        studentAcademicPercentage: '',
      },
      {
        StudentAcademicsDegree: 'Graduation',
        studentAcademicInstitution: '',
        studentAcademicStream: '',
        studentAcademicCompletionYear: '',
        studentAcademicPercentage: '',
      },
      {
        StudentAcademicsDegree: 'Post Graduation',
        studentAcademicInstitution: '',
        studentAcademicStream: '',
        studentAcademicCompletionYear: '',
        studentAcademicPercentage: '',
      },
    ],
    workExperiences: [
      {
        studentWorkExperienceCompanyName: '',
        studentWorkExperienceDesignation: '',
        studentWorkExperienceProfile: '',
        studentWorkExperienceYear: '',
        studentWorkExperienceMonth: '',
      },
    ],
    courses: {
      courseId: '',
      batchId: '',
      branchId: '',
      courseExpectation: '',
      courseFees: 0,
      discount: '',
      totalFees: 0,
      feesStructure: 'oneTime',
      registrationAmount: '',
      registrationAmountDate: '',
    },
    feesCollection: {
      collectionDate: '',
      paidAmount: '',
      paymentMode: '',
      paymentRemarks: '',
      paymentMethod: '',
    },
    paymentHistory: [
      {
        amount: null,
        date: null,
      },
    ],
  })
  const { inquiryEnrollData, branchListData, loading } = useSelector((state) => state.enrollment)
  const [feesDetails, setFeesDetails] = useState({
    onetimeFees: 0,
    installmentFees: 0,
    oneTimeData: [],
    installmentData: [],
    registrationDetails: {}
  })
  const branchList = branchListData?.map((branch) => {
    return {
      label: branch.branch.branchName,
      value: branch.branch.branchId,
    }
  })
  const batches = useSelector((state) => state.course.batchList)
  const { tempCitiesAreas, tempStateCities, tempStates } = useSelector((state) => state?.masterDataSet)

  const enrollmentData = useSelector((state) => state.enrollment.enrollmentData)
  const { CitiesAreas, stateCities, states } = useSelector((state) => state.masterDataSet)

  const courses = useSelector((state) => state.course.course)
  const courseList = courses?.map((course) => {
    return {
      label: course.courseName,
      value: course.courseId,
    }
  })
  const validationSchema = Yup.object().shape({
    enrollmentDate: Yup.date().required(VALIDATION_MESSAGES.ENROLLMENT_FORM.ENROLLMENT_DATE),
    parentPhone: Yup.string().matches(/^[0-9]{10}$/, VALIDATION_MESSAGES.ENROLLMENT_FORM.PARENT_PHONE_VALID),
    studentCode: Yup.string().required(VALIDATION_MESSAGES.ENROLLMENT_FORM.STUDENT_CODE),
    studentName: Yup.string().required(VALIDATION_MESSAGES.ENROLLMENT_FORM.STUDENT_NAME),
    studentEmail: Yup.string()
      .matches(/\S+@\S+\.\S+/, VALIDATION_MESSAGES.ENROLLMENT_FORM.STUDENT_EMAIL_VALID)
      .required(VALIDATION_MESSAGES.ENROLLMENT_FORM.STUDENT_EMAIL_REQUIRED),
    studentPassword: id
      ? Yup.string().optional()
      : Yup.string()
        .required(VALIDATION_MESSAGES.PASSWORD_REQUIRED)
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          VALIDATION_MESSAGES.PASSWORD_VALID,
        ),
    studentPhone: Yup.string()
      .matches(/^[0-9]{10}$/, VALIDATION_MESSAGES.ENROLLMENT_FORM.STUDENT_PHONE_VALID)
      .required(VALIDATION_MESSAGES.ENROLLMENT_FORM.STUDENT_PHONE_REQUIRED),
    studentBirthDate: Yup.date().required(VALIDATION_MESSAGES.ENROLLMENT_FORM.STUDENT_BIRTH_DATE_REQUIRED),
    academics: Yup.array().of(
      Yup.object().shape({
        StudentAcademicsDegree: Yup.string().optional(),
        studentAcademicInstitution: Yup.string().optional(),
        studentAcademicStream: Yup.string().optional(),
        studentAcademicCompletionYear: Yup.string()
          .matches(/^[0-9]{4}$/, VALIDATION_MESSAGES.COMPLETION_YEAR)
          .optional(),
        studentAcademicPercentage: Yup.number()
          .min(0, VALIDATION_MESSAGES.MIN_PERCENTAGE)
          .max(100, VALIDATION_MESSAGES.MAX_PERCENTAGE)
          .optional(),
      }),
    ),
    workExperiences: Yup.array().of(
      Yup.object().shape({
        studentWorkExperienceCompanyName: Yup.string().optional(),
        studentWorkExperienceDesignation: Yup.string().optional(),
        studentWorkExperienceProfile: Yup.string().optional(),
        studentWorkExperienceYear: Yup.number().min(0, VALIDATION_MESSAGES.MIN_YEAR).optional(),
        studentWorkExperienceMonth: Yup.string()
          .min(0, VALIDATION_MESSAGES.MIN_MONTH)
          .max(11, VALIDATION_MESSAGES.MIN_MONTH)
          .optional(),
      }),
    ),
    courses: Yup.object().shape({
      courseId: Yup.string().required(VALIDATION_MESSAGES.COURSE_REQUIRED),
      batchId: Yup.string().required(VALIDATION_MESSAGES.BATCH_REQUIRED),
      branchId: Yup.string().required(VALIDATION_MESSAGES.BRANCH_REQUIRED),
      courseFees: Yup.number().positive().required(VALIDATION_MESSAGES.COURSE_FEES_REQUIRED),
      discount: Yup.number().min(0),
      totalFees: Yup.number().positive().required(VALIDATION_MESSAGES.TOTAL_FEES_REQUIRED),
      feesStructure: Yup.string().required(VALIDATION_MESSAGES.FEE_STRUCTURE),
      registrationAmount: Yup.string().required(VALIDATION_MESSAGES.REGISTRATION_AMOUNT),
    }),
    feesCollection: Yup.object().shape({
      collectionDate: Yup.string().optional(),
      paidAmount: Yup.number().optional(),
      paymentMode: Yup.string().optional(),
      paymentRemarks: Yup.string().optional(),
      paymentMethod: Yup.string().optional(),
    }).when('$id', {
      is: (ee) => !id,
      then: () => Yup.object().shape({
        collectionDate: Yup.string().required('Collection date is required'),
        paidAmount: Yup.number()
          .required('Paid amount is required')
          .test(
            'is-equal-to-registration-amount',
            'Paid amount must equal registration amount',
            function (value) {
              const { courses } = this?.options?.context ?? {};
              const { registrationAmount } = courses ?? {};
              const { paymentMethod } = this?.parent ?? {};
              if (paymentMethod === "registration") {
                return value == registrationAmount;
              }
              return true;
            }
          ),
        paymentMode: Yup.string().required('Payment mode is required'),
        paymentRemarks: Yup.string().optional(),
        paymentMethod: Yup.string()
          .required('Payment method is required')
          .test('is-registration-selected', 'Please add first registration fees', function (value) {
            if (value === "registration") {
              return true;
            }
            return false;
          })
      }),
      otherwise: () => Yup.object().shape({
        collectionDate: Yup.string().optional(),
        paidAmount: Yup.number().optional(),
        paymentMode: Yup.string().optional(),
        paymentRemarks: Yup.string().optional(),
        paymentMethod: Yup.string().optional(),
      }),
    })
  })
  const breadCrumbsArr = [
    {
      title: id ? UI_CONSTANT.ENROLLMENT.EDIT_ENROLLMENT : UI_CONSTANT.ENROLLMENT.ADD_ENROLLMENT,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.ENROLLMENT.LABEL_ENROLLMENT,
      link: ROUTES_PATH.ENROLLMENT,
    },
    {
      title: id ? UI_CONSTANT.ENROLLMENT.EDIT_ENROLLMENT : UI_CONSTANT.ENROLLMENT.ADD_ENROLLMENT,
      link: id ? ROUTES_PATH.EDIT_ENROLLMENT.replace(':id', id) : ROUTES_PATH.ADD_ENROLLMENT,
    },
  ]
  const handleOneShotRadioChange = (setFieldValue, value, values) => {
    setFieldValue('courses.feesStructure', value)
    setFieldValue('courses.courseFees', feesDetails.onetimeFees)
    let payHistory = feesDetails.oneTimeData
    const totalFees = Number(feesDetails.onetimeFees) - Number(values.courses.discount || 0)

    let foundPayment = payHistory.reduce((acc, item) => {
      if (item.paymentOn) {
        acc = item.amount + acc
      }
      return acc
    }, 0)
    setFieldValue('courses.totalFees', totalFees)
    !id && setFieldValue('courses.registrationAmount', '')
    const updateInstallment = feesDetails.oneTimeData.map((item) => ({ ...item, amount: item.amount - (values.courses.discount || 0) }))
    setFieldValue('paymentHistory', updateInstallment)
    // manageDiscountedAmount(
    //   values,
    //   setFieldValue,
    //   values,
    //   Number(values.courses.discount || 0),
    //   totalFees.toString(),
    //   null, //setFunction
    //   values.courses.registrationAmount,
    //   foundPayment, //payment on
    //   value,
    // )
  }

  const handleInstallmentRadioChange = (setFieldValue, value, values) => {
    setFieldValue('courses.feesStructure', value)
    setFieldValue('courses.courseFees', feesDetails.installmentFees)
    const totalFees = feesDetails.installmentFees - values.courses.discount

    setFieldValue('courses.totalFees', totalFees)
    let payHistory = feesDetails.installmentData

    let foundPayment = payHistory.reduce((acc, item) => {
      if (item.paymentOn) {
        acc = item.amount + acc
      }
      return acc
    }, 0)
    !id && setFieldValue('courses.registrationAmount', '')

    const updateInstallment = feesDetails.installmentData.map((item) => ({ ...item, amount: item.amount - (values.courses.discount || 0) }))
    setFieldValue('paymentHistory', updateInstallment)
    // manageDiscountedAmount(
    //   !values?.paymentHistory ? [{ paymentHistory: feesDetails.installmentData }] : values,
    //   setFieldValue,
    //   values,
    //   values.courses.discount,
    //   totalFees.toString(),
    //   null, //setFunction
    //   values.courses.registrationAmount,
    //   foundPayment, //payment on
    //   value,
    // )
  }

  const countObj = {
    1: 'First Installment',
    2: 'Second Installment',
    3: 'Third Installment',
    4: 'Fourth Installment',
    5: 'Fifth Installment',
    6: 'Sixth Installment',
    7: 'Seventh Installment',
    8: 'Eighth Installment',
    9: 'Ninth Installment',
    10: 'Tenth Installment',
    11: 'Eleventh Installment',
    12: 'Twelfth Installment',
  }
  useEffect(() => {
    const oldEnrollId = location.search ? new URLSearchParams(location.search).get('oldEnrollment') : null
    dispatch(getCourse('publish'))
    if (!id && !oldEnrollId) {
      // eslint-disable-next-line no-unsafe-optional-chaining
      const { inquiryData } = location?.state
      if (inquiryData) {
        if (
          inquiryData.permanentAreaId === inquiryData.temporaryArea &&
          inquiryData.permanentCityId === inquiryData.temporaryCity &&
          inquiryData.permanentStateId === inquiryData.temporaryState &&
          inquiryData.temporaryAddress === inquiryData.permanentAddress
        ) {
          setIsSameAddress(true)
        }

        setInitialValues({
          ...initialValues,
          permanentAddress: inquiryData.permanentAddress,
          permanentArea: inquiryData.permanentAreaId,
          permanentCity: inquiryData.permanentCityId,
          permanentState: inquiryData.permanentStateId,
          temporaryAddress: inquiryData.temporaryAddress,
          temporaryArea: inquiryData.temporaryArea,
          temporaryState: inquiryData.temporaryState,
          temporaryCity: inquiryData.temporaryCity,
          studentName: inquiryData.name,
          studentEmail: inquiryData.email,
          studentPhone: inquiryData.phone,
        })
      }
    } else if (location?.search && oldEnrollId) {

      const fetchData = async () => {
        if (oldEnrollId) {
          try {
            const data = await getEnrollmentDetails(oldEnrollId)
            //   const oneTimeInfo = data.paymentHistory.filter((e) => e.type == 'onetime')
            // const installmentInfo = data.paymentHistory.filter((e) => e.type == 'installment')
            setInitialValues({
              ...data, courses: {
                courseId: '',
                batchId: '',
                branchId: '',
                courseExpectation: '',
                courseFees: 0,
                discount: '',
                totalFees: 0,
                feesStructure: 'oneTime',
                registrationAmount: '',
                registrationAmountDate: '',
              }, studentStatus: 'active', paymentHistory: [{ amount: null, date: null }]
            })
            // dispatch(getBranchList({ courseId: data.courses.courseId, courseBranchesFess: 'fees' }))
            // dispatch(getBatchList({ value: data.courses.branchId, courseId: data.courses.courseId, branchFees: 'fees' }))
          } catch (error) {
            console.error('Error fetching enrollment details:', error)
          }
        }
      }
      fetchData()
    }

  }, [])

  const getEnrollmentDetails = async (enrId) => {
    const oldEnrollId = location.search ? new URLSearchParams(location.search).get('oldEnrollment') : null

    let url = `/student/enrollment/${enrId}`
    const response = await apiClient.get(url)
    setEnroll(response)

    if (!oldEnrollId) {
      if (response.status) {
        let feeurl = API_ROUTES.ENROLLMENT.GET_FEE_STRUCTURE(
          response.data.result.courses.courseId,
          response.data.result.courses.batchId,
          response.data.result.courses.branchId,
          enrId,
        )
        let feeResponse = await apiClient.get(feeurl)
        const array = response.data.result.paymentHistory.filter((e) => e.paymentOn == null)
        setState(array)
        if (array.length > 0) {
          setFeesDetails({
            installmentFees: feeResponse.data.result.installmentFees,
            onetimeFees: feeResponse.data.result.onetimeFees,
            oneTimeData: feeResponse?.data?.result?.paymentHistory['onetime'],
            installmentData: feeResponse?.data?.result?.paymentHistory['installment'],
            registrationDetails: feeResponse?.data?.result?.studentRegHistory
          })
        } else {
          const oneTimeInfo = response.data.result.paymentHistory.filter((e) => e.type == 'onetime')
          const installmentInfo = response.data.result.paymentHistory.filter((e) => e.type == 'installment')
          setFeesDetails({
            installmentFees: feeResponse.data.result.installmentFees,
            onetimeFees: feeResponse.data.result.onetimeFees,
            oneTimeData: oneTimeInfo,
            installmentData: installmentInfo,
            registrationDetails: feeResponse?.data?.result?.studentRegHistory
          })
        }

        return response.data.result
      }
    }

    return response?.data?.result
  }

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        try {
          const data = await getEnrollmentDetails(id)
          const oneTimeInfo = data.paymentHistory.filter((e) => e.type == 'onetime')
          const installmentInfo = data.paymentHistory.filter((e) => e.type == 'installment')
          setInitialValues({ ...data, paymentHistory: data?.courses?.feesStructure == "oneTime" ? oneTimeInfo : installmentInfo })
          dispatch(getBranchList({ courseId: data.courses.courseId, courseBranchesFess: 'fees' }))
          dispatch(getBatchList({ value: data.courses.branchId, courseId: data.courses.courseId, branchFees: 'fees' }))
        } catch (error) {
          console.error('Error fetching enrollment details:', error)
        }
      }
    }
    fetchData()
  }, [id])
  const manageDiscountedAmount = (
    data,
    setFieldValue,
    values,
    discountValue = 0,
    totalFees = 0,
    setPaymentHistory,
    registrationAmount = 0,
    paymentOn = null,
    value = '',
  ) => {
    const updateOneTimePaymentHistory = data?.paymentHistory?.map((i) => {
      const updatedAmount = (Number(totalFees) - Number(registrationAmount)) / data?.paymentHistory?.length
      return {
        ...i,
        // amount: registrationAmount ? Number(updatedAmount) - Number(registrationAmount) : updatedAmount,
        amount: Number(updatedAmount),
        // amount: paymentOn?.paymentOn
        // ? Number(updatedAmount) - (Number(registrationAmount) + Number(paymentOn?.amount))
        // : registrationAmount
        // ? Number(updatedAmount) - Number(registrationAmount)
        // : updatedAmount,
      }
    })
    if (value) {
      setFieldValue('paymentHistory', updateOneTimePaymentHistory)
    } else {
      setFieldValue('paymentHistory', updateOneTimePaymentHistory)
    }
    // setPaymentHistory({
    //   ...data,
    //   paymentHistory: { onetime: updateOneTimePaymentHistory, installment: updateInstallmentPaymentHistory },
    // })
  }

  const manageInstallmentDate = (setFieldValue, values, date) => {
    date = convertDateFormatCalendar(date)
    const updateOneTimePaymentHistory = values?.paymentHistory?.map((i) => {
      return {
        ...i,
        date: date
          ? convertDateFormatCalendar(dayjs(date).add(1, 'month').format('DD/MM/YYYY'))
          : convertDateFormatCalendar(dayjs().format('DD/MM/YYYY')),
      }
    })
    setFieldValue('paymentHistory', updateOneTimePaymentHistory)
  }
  const handleStateOnChange = (e, setFieldValue) => {
    e.preventDefault()
    const stateId = e.target.value
    setFieldValue('permanentState', stateId)
    stateId ? dispatch(getCityByStateId(stateId)) : ''
    setFieldValue('permanentCity', '')
    setFieldValue('permanentArea', '')
    if (isSameAddress) {
      setFieldValue('temporaryState', stateId)
    }
  }

  const handleCityOnChange = (e, setFieldValue) => {
    e.preventDefault()
    const cityId = e.target.value
    setFieldValue('permanentCity', cityId)
    cityId ? dispatch(getAreaByCityId(cityId)) : ''
    if (isSameAddress) {
      setFieldValue('temporaryCity', cityId)
    }
  }

  const handleAreaOnchange = (e, setFieldValue) => {
    e.preventDefault()
    const areaId = e.target.value
    setFieldValue('permanentArea', areaId)
    if (isSameAddress) {
      setFieldValue('temporaryArea', areaId)
    }
  }

  const handleTempStateOnChange = (e, setFieldValue) => {
    e.preventDefault()
    const TempStateId = e.target.value
    setFieldValue('temporaryState', TempStateId)
    TempStateId ? dispatch(getTempCityByStateId(TempStateId)) : ''
    setFieldValue('temporaryCity', '')
    setFieldValue('temporaryArea', '')
  }

  const handleTempCityOnChange = (e, setFieldValue) => {
    e.preventDefault()
    const TempCityId = e.target.value
    setFieldValue('temporaryCity', TempCityId)
    TempCityId ? dispatch(getTempAreaByCityId(TempCityId)) : ''
  }

  const handleTempAreaOnchange = (e, setFieldValue) => {
    e.preventDefault()
    const TempAreaId = e.target.value
    setFieldValue('temporaryArea', TempAreaId)
  }

  const handleCourseDropdownChange = (value, setFieldValue) => {
    setFieldValue('courses.courseId', value)
    setFieldValue('courses.branchId', '')
    setFieldValue('courses.batchId', '')
    // setFieldValue('courses.registrationAmount', '')
    const feesValue = 'fees'
    dispatch(getBranchList({ courseId: value, courseBranchesFess: feesValue }))
    setFieldValue('courses.batchId', '')
  }

  const handleBranchDropdownChange = (value, courseId, setFieldValue) => {
    setFieldValue('courses.branchId', value)
    setFieldValue('courses.batchId', '')
    // setFieldValue('courses.registrationAmount', '')
    const branchFees = 'fees'
    dispatch(getBatchList({ value, courseId, branchFees }))
  }
  const handleBatchDropdownChange = async (value, courseId, branchId, setFieldValue, values) => {
    setFieldValue('courses.batchId', value)
    let url = API_ROUTES.ENROLLMENT.GET_FEE_STRUCTURE(courseId, value, branchId)
    const response = await apiClient.get(url)
    const totalFees = Number(response.data.result.onetimeFees) - Number(initialValues.courses.discount)
    if (!id || state?.length > 0) {
      setFeesDetails({
        installmentFees: response?.data.result.installmentFees,
        onetimeFees: response.data.result.onetimeFees,
        oneTimeData: response?.data?.result?.paymentHistory['onetime'],
        installmentData: response?.data?.result?.paymentHistory['installment'],
        registrationDetails: response?.data?.result?.studentRegHistory
      })
    } else {
      const oneTimeInfo = enroll?.data?.result?.paymentHistory.filter((e) => e.type === 'onetime')
      const installmentInfo = enroll?.data?.result?.paymentHistory.filter((e) => e.type === 'installment')
      setFeesDetails({
        installmentFees: response?.data.result.installmentFees,
        onetimeFees: response.data.result.onetimeFees,
        oneTimeData: oneTimeInfo,
        installmentData: installmentInfo,
        registrationDetails: response?.data?.result?.studentRegHistory
      })
    }

    if (response.status) {
      manageDiscountedAmount(
        !values?.paymentHistory ? [{ paymentHistory: response?.data?.result?.paymentHistory['onetime'] }] : values,
        setFieldValue,
        values,
        values.courses.discount,
        totalFees.toString(),
        null, //setFunction
        values.courses.registrationAmount,
        null, //payment on
        value,
      )
      setFieldValue('courses.courseFees', response.data.result.onetimeFees)
      id
        ? setFieldValue('courses.totalFees', totalFees)
        : setFieldValue('courses.totalFees', response.data.result.onetimeFees)
      // setFieldValue('courses.registrationAmount', '')
    } else {
      setFieldValue('courses.courseFees', '')
      setFieldValue('courses.totalFees', '')
      setFieldValue('paymentHistory', [])
      dispatch(setCourseFeesStructData(null))
      // setFieldValue('courses.registrationAmount', '')
    }
    setFieldValue('courses.feesStructure', 'oneTime')
  }

  const handleDiscountChange = (value, setFieldValue, values) => {
    setFieldValue('courses.discount', value)
    const totalFees = Number(values.courses.courseFees) - Number(value)
    setFieldValue('courses.totalFees', totalFees)

    manageDiscountedAmount(
      values,
      setFieldValue,
      values,
      values.courses.discount,
      totalFees.toString(),
      null, //setFunction
      values.courses.registrationAmount,
      null, //payment on
      value,
    )
  }

  const handleRegistrationAmountChange = (value, setFieldValue, values) => {
    setFieldValue('courses.registrationAmount', value)
    manageDiscountedAmount(
      values,
      setFieldValue,
      values,
      values.courses.discount,
      values.courses.totalFees,
      null, //setFunction
      value,
      null, //payment on
      value,
    )
  }
  const handleRegistrationDateChange = (date, setFieldValue, formData) => {
    setFieldValue('courses.registrationAmountDate', convertDateFormatCalendar(date))
    // manageInstallmentDate(setFieldValue, formData, date)
  }

  const handlePaymentMethod = (e, setFieldValue, values) => {
    setFieldValue('feesCollection.paymentMethod', e.target.value)
    if (e.target.value === "registration") {
      setFieldValue('feesCollection.paidAmount', values?.courses?.registrationAmount)
    }
    if (e.target.value === "Full payment") {
      setFieldValue('feesCollection.paidAmount', values?.paymentHistory[0]?.amount?.toString())
    }
    values?.paymentHistory?.map((val) => {
      if (val?.type === 'installment') {
        if (val?.installmentType == countObj[e.target.value]) {
          setFieldValue('feesCollection.paidAmount', val?.amount.toString())
        }
      }
    })
  }
  function handleFormSubmit(payload) {
    if (payload && payload?.paymentHistory) {
      payload?.paymentHistory?.forEach((payment) => {
        // delete payment?.paymentOn
        delete payment.installmentNo
        delete payment.type
        delete payment.installmentType
      })
    }
    if (id) {
      dispatch(editStudentEnrollmentData({ payload, id, navigate }))
    } else {
      const oldEnrollId = location.search ? new URLSearchParams(location.search).get('oldEnrollment') : null

      if (oldEnrollId) {
        dispatch(createEnrollment({ inquiryId: null, payload: { ...payload, student_id: oldEnrollId }, navigate }))
      } else {
        dispatch(createEnrollment({ inquiryId: inquiryEnrollData.inquiryId, payload, navigate }))
      }
    }
  }

  const handleCheckboxChange = (setFieldValue, values) => (event) => {
    setIsSameAddress(event.target.checked)

    if (event.target.checked) {
      setFieldValue('temporaryAddress', values.permanentAddress)
      setFieldValue('temporaryArea', values.permanentArea)
      setFieldValue('temporaryCity', values.permanentCity)
      setFieldValue('temporaryState', values.permanentState)
    } else {
      setFieldValue('temporaryAddress', '')
      setFieldValue('temporaryArea', '')
      setFieldValue('temporaryCity', '')
      setFieldValue('temporaryState', '')
    }
  }

  const handleDeleteInstallment = (remove, index, values, setFieldValue) => {
    // values.paymentHistory.splice(index, 1)
    // manageDiscountedAmount(
    //   values,
    //   setFieldValue,
    //   values,
    //   values.courses.discount,
    //   values.courses.totalFees,
    //   null, //setFunction
    //   values.courses.registrationAmount,
    //   null, //payment on
    //   null,
    // )
    remove(index)
  }
  return (
    <>
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && (
        <div className='enrollmentForm-wrapper'>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            context={{ id: id }}
            onSubmit={(values) => {
              // handleFormSubmit()
              const payload = { ...values }
              handleFormSubmit(payload)
            }}
            enableReinitialize
          >
            {({ values, handleChange, handleSubmit, setFieldValue }) => (
              <Form>
                <div className='enrollmentForm-header'>
                  <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
                  <div className='enrollmentForm-header-right'>
                    <Button customClassName={'save-btn'} onClick={handleSubmit}>
                      {UI_CONSTANT.SAVE}
                    </Button>
                  </div>
                </div>
                <div className='enrollmentForm'>
                  <div className='enrollment-header'>
                    <div className='enrollmentForm-inner-header'>
                      <h1>{UI_CONSTANT.ENROLLMENT.PERSONAL_INFORMATION}</h1>
                      <p>{UI_CONSTANT.ENROLLMENT.FORM_DESCRIPTION}</p>
                    </div>
                    <div className='innerClass inquiryForm-input'>
                      <div className='button-group'>
                        <Button
                          customClassName={values.studentStatus == 'active' ? 'active-btn' : 'inactive-btn'}
                          type='button'
                          onClick={() => {
                            setFieldValue('studentStatus', 'active')
                          }}
                        >
                          Alive
                        </Button>
                        <Button
                          customClassName={values.studentStatus == 'inactive' ? 'active-btn' : 'inactive-btn'}
                          type='button'
                          onClick={() => {
                            setFieldValue('studentStatus', 'inactive')
                          }}
                        >
                          Dead
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className='separatorLine'></div>

                  <div className='enrollmentForm-input-fields'>
                    <NewInput
                      label='Student Name'
                      placeholder='Enter name'
                      name='studentName'
                      width={'32%'}
                      required={true}
                      onInput={handleName}
                    />

                    <NewInput
                      label='Student Email'
                      placeholder='Enter Email'
                      name='studentEmail'
                      width={'32%'}
                      required={true}
                      onInput={handleEmail}
                      maxLength={50}
                      autoComplete='off'
                    />

                    {!id ? (
                      <NewInput
                        label='Student Password'
                        placeholder='Enter Password'
                        name='studentPassword'
                        width={'32%'}
                        required={true}
                        type={'password'}
                        minLength={8}
                        onInput={handlePassword}
                        autoComplete='new-password'
                      />
                    ) : null}

                    <NewInput
                      label='Student Phone'
                      placeholder='Enter Phone number'
                      name='studentPhone'
                      width={'32%'}
                      required={true}
                      onInput={handleInput}
                      maxLength={10}
                      type={'text'}
                    />

                    <Calendar
                      label='Registration Date'
                      name='enrollmentDate'
                      required={true}
                      width='32%'
                      value={values.enrollmentDate}
                      defaultToToday={true}
                      disabled={false}
                      onChange={(values) => setFieldValue('enrollmentDate', convertDateFormatCalendar(values))}
                    />
                    <Calendar
                      maxBirthDate={true}
                      label='Birth Date'
                      name='studentBirthDate'
                      width={'32%'}
                      type={'date'}
                      required={true}
                      value={values.studentBirthDate}
                      onChange={(values) => setFieldValue('studentBirthDate', convertDateFormatCalendar(values))}
                    />

                    <NewInput
                      label='Father Name'
                      placeholder='Enter father name'
                      name='fatherName'
                      width={'32%'}
                      onInput={handleName}
                    />
                    <NewInput
                      label='Mother Name'
                      placeholder='Enter mother name'
                      name='motherName'
                      width={'32%'}
                      onInput={handleName}
                    />
                    <NewInput
                      label="Parent's Mobile"
                      placeholder='Enter parents number'
                      name='parentPhone'
                      width={'32%'}
                      type={'text'}
                      onInput={handleInput}
                      maxLength={10}
                    />
                    <div className='enrollmentForm-input'>
                      <label htmlFor=''>Permanent State</label>
                      <PageDropdown
                        options={generateDropdownOptions(states, 'state_name', 'state_id')}
                        selectedValue={values.permanentState}
                        className={'enrollmentForm-dropdown'}
                        onChange={(e) => handleStateOnChange(e, setFieldValue)}
                        name={'permanentState'}
                        placeholder={'Select permanent state'}
                      />
                      <ErrorMessage name='permanentState' component='div' className='error-msg' />
                    </div>

                    <div className='enrollmentForm-input'>
                      <label htmlFor=''>Permanent City</label>
                      <PageDropdown
                        options={generateDropdownOptions(stateCities, 'city_name', 'city_id')}
                        selectedValue={values.permanentCity}
                        className={'enrollmentForm-dropdown'}
                        onChange={(e) => handleCityOnChange(e, setFieldValue)}
                        name={'permanentCity'}
                        placeholder={'Select permanent city'}
                        disabled={!values.permanentState}
                      />
                      <ErrorMessage name='permanentCity' component='div' className='error-msg' />
                    </div>
                    <div className='enrollmentForm-input'>
                      <label htmlFor=''>Permanent Area</label>
                      <PageDropdown
                        options={generateDropdownOptions(CitiesAreas, 'area_name', 'area_id')}
                        selectedValue={values.permanentArea}
                        className={'enrollmentForm-dropdown'}
                        onChange={(e) => handleAreaOnchange(e, setFieldValue)}
                        name={'permanentArea'}
                        placeholder={'Select permanent Area'}
                        disabled={!values.permanentCity}
                      />
                      <ErrorMessage name='permanentArea' component='div' className='error-msg' />
                    </div>
                    <NewInput
                      label='Permanent Address'
                      placeholder='Enter full address'
                      name='permanentAddress'
                      width={'98%'}
                      onInput={handleInputAddress}
                      maxLength={100}
                    />

                    <div className='inquiryForm-input1 temporary-address-check'>
                      <Field
                        type='checkbox'
                        name='sameAsPermanent'
                        checked={isSameAddress}
                        onChange={handleCheckboxChange(setFieldValue, values)}
                        className={`${isSameAddress ? 'custom-checkbox-checked' : ''}`}
                      />
                      <p>Temporary Address Same as Above</p>
                    </div>

                    <div className='enrollmentForm-input'>
                      <label htmlFor=''>Temporary State</label>
                      <PageDropdown
                        options={generateDropdownOptions(states, 'state_name', 'state_id')}
                        selectedValue={values.temporaryState}
                        className={'enrollmentForm-dropdown'}
                        onChange={(e) => handleTempStateOnChange(e, setFieldValue)}
                        name={'temporaryState'}
                        placeholder={'Select State'}
                        disabled={isSameAddress}
                      />
                      <ErrorMessage name='temporaryCity' component='div' className='error-msg' />
                    </div>

                    <div className='enrollmentForm-input'>
                      <label htmlFor=''>Temporary City</label>
                      <PageDropdown
                        options={
                          isSameAddress || id
                            ? generateDropdownOptions(stateCities, 'city_name', 'city_id')
                            : generateDropdownOptions(tempStateCities, 'city_name', 'city_id')
                        }
                        selectedValue={values.temporaryCity}
                        className={'enrollmentForm-dropdown'}
                        onChange={(e) => handleTempCityOnChange(e, setFieldValue)}
                        name={'temporaryCity'}
                        placeholder={'Select  city'}
                        disabled={isSameAddress || !values.temporaryState}
                      />
                      <ErrorMessage name='temporaryCity' component='div' className='error-msg' />
                    </div>
                    <div className='enrollmentForm-input'>
                      <label htmlFor=''>Temporary Area</label>
                      <PageDropdown
                        options={
                          isSameAddress || id
                            ? generateDropdownOptions(CitiesAreas, 'area_name', 'area_id')
                            : generateDropdownOptions(tempCitiesAreas, 'area_name', 'area_id')
                        }
                        selectedValue={values.temporaryArea}
                        className={'enrollmentForm-dropdown'}
                        onChange={(e) => handleTempAreaOnchange(e, setFieldValue)}
                        name={'temporaryArea'}
                        placeholder={'Select  Area'}
                        disabled={isSameAddress || !values.temporaryCity}
                      />
                      <ErrorMessage name='temporaryArea' component='div' className='error-msg' />
                    </div>

                    <NewInput
                      label='Temporary Address'
                      placeholder='Enter full address'
                      name='temporaryAddress'
                      width={'98%'}
                      disabled={isSameAddress}
                      onInput={handleInputAddress}
                      maxLength={100}
                    />
                  </div>
                </div>

                <div className='enrollmentForm'>
                  <div className='enrollmentForm-inner-header'>
                    <h1>{UI_CONSTANT.ENROLLMENT.ACADEMIC_DETAILS}</h1>
                    <p>{UI_CONSTANT.ENROLLMENT.FORM_DESCRIPTION}</p>
                  </div>

                  <div className='separatorLine'></div>

                  <div className='enrollmentForm-input-fields-new-enrollment'>
                    <FieldArray name='academics'>
                      {() => (
                        <>
                          {values?.academics?.map((value, index) => {
                            const checkIndex = (lable, index) => {
                              if (index === 0) {
                                return lable
                              } else {
                                return null
                              }
                            }
                            return (
                              <div className='academic-input-div' key={index}>
                                <label htmlFor='' className='academic-label-first'>
                                  {checkIndex(<p>Degree</p>, index)}
                                  <p className={`hsc-label ${index > 0 ? 'mt-17' : ''}`}>
                                    {value.StudentAcademicsDegree}
                                  </p>
                                </label>
                                <div className='schoolName-div'>
                                  <NewInput
                                    label={checkIndex('School Name', index)}
                                    placeholder='Enter school name'
                                    name={`academics[${index}].studentAcademicInstitution`}
                                    width={'100%'}
                                    onInput={handleInputStringWithNum}
                                  />
                                </div>

                                <NewInput
                                  label={checkIndex('Stream', index)}
                                  placeholder='Enter stream'
                                  name={`academics[${index}].studentAcademicStream`}
                                  width={'18%'}
                                  onInput={handleName}
                                />

                                <div className='completion-year-div'>
                                  <NewInput
                                    label={checkIndex('Completion Year', index)}
                                    placeholder='Year'
                                    name={`academics[${index}].studentAcademicCompletionYear`}
                                    width={'100%'}
                                    type='text'
                                    maxLength={4}
                                    onInput={handleInput}
                                  />
                                </div>

                                <NewInput
                                  label={checkIndex('Percentage', index)}
                                  placeholder='00.00'
                                  name={`academics[${index}].studentAcademicPercentage`}
                                  width={'14%'}
                                  type='text'
                                  onInput={handlePercentageInput}
                                />
                              </div>
                            )
                          })}
                        </>
                      )}
                    </FieldArray>
                  </div>
                </div>

                <div className='enrollmentForm'>
                  <div className='enrollmentForm-inner-header'>
                    <h1>{UI_CONSTANT.ENROLLMENT.ACADEMIC_DETAILS}</h1>
                    <p>{UI_CONSTANT.ENROLLMENT.FORM_DESCRIPTION}</p>
                  </div>

                  <div className='separatorLine'></div>

                  <div className='enrollmentForm-input-fields'>
                    <FieldArray name='workExperiences'>
                      {({ push, remove }) => (
                        <>
                          {values?.workExperiences?.map((value, index) => {
                            return (
                              <div className='enrollmentForm-input-fields' key={index}>
                                <NewInput
                                  label='Name of Company'
                                  placeholder='Enter company name'
                                  name={`workExperiences[${index}].studentWorkExperienceCompanyName`}
                                  width={'32%'}
                                  onInput={handleInputStringWithNum}
                                />
                                <NewInput
                                  label='Designation'
                                  placeholder='Enter designation'
                                  name={`workExperiences[${index}].studentWorkExperienceDesignation`}
                                  width={'19%'}
                                  onInput={handleName}
                                />
                                <NewInput
                                  label='Profile'
                                  placeholder='Enter Profile'
                                  name={`workExperiences[${index}].studentWorkExperienceProfile`}
                                  width={'14.75%'}
                                  onInput={handleInputStringWithNum}
                                />
                                <NewInput
                                  label='Exp. Year'
                                  placeholder='Enter Exp. Year'
                                  name={`workExperiences[${index}].studentWorkExperienceYear`}
                                  width={'14.75%'}
                                  onInput={handleInput}
                                  maxLength={4}
                                />
                                <div className='enrollmentForm-input-small'>
                                  <label htmlFor=''>Exp. Months</label>
                                  <PageDropdown
                                    options={months}
                                    selectedValue={values?.workExperiences[index]?.studentWorkExperienceMonth}
                                    className={'enrollmentForm-dropdown'}
                                    onChange={handleChange}
                                    name={`workExperiences[${index}].studentWorkExperienceMonth`}
                                    placeholder={'Exp. Months'}
                                  />
                                  <ErrorMessage
                                    name={`workExperiences[${index}].studentWorkExperienceMonth`}
                                    component='div'
                                    className='error-msg'
                                  />
                                </div>
                                {index !== 0 && (
                                  <div
                                    className='delete-mag-div'
                                    onClick={() => {
                                      remove(index)
                                    }}
                                  >
                                    <img src={deleteIcon} alt='deleteIcon' />
                                  </div>
                                )}
                              </div>
                            )
                          })}
                          <div className='addCompany-btn-div'>
                            <Button
                              type='button'
                              customClassName={'addCompany-btn-div'}
                              onClick={() => {
                                push({
                                  studentWorkExperienceCompanyName: '',
                                  studentWorkExperienceDesignation: '',
                                  studentWorkExperienceProfile: '',
                                  studentWorkExperienceYear: '',
                                  studentWorkExperienceMonth: '',
                                })
                              }}
                            >
                              <u>Add New Company</u>
                            </Button>
                          </div>
                        </>
                      )}
                    </FieldArray>
                  </div>
                </div>

                <div className='enrollmentForm'>
                  <div className='enrollmentForm-inner-header'>
                    <h1>{UI_CONSTANT.ENROLLMENT.COURSE_DETAILS}</h1>
                    <p>{UI_CONSTANT.ENROLLMENT.FORM_DESCRIPTION}</p>
                  </div>

                  <div className='separatorLine'></div>

                  <div className='enrollmentForm-input-fields'>
                    <NewInput
                      label='Course Expectation'
                      placeholder='Enter name'
                      name='courses.courseExpectation'
                      width={'98%'}
                      onInput={handleName}
                    />

                    <div className='enrollmentForm-input'>
                      <label htmlFor=''>
                        Course Selection<span className='required-symbol'>*</span>
                      </label>
                      <PageDropdown
                        options={courseList}
                        selectedValue={values?.courses?.courseId}
                        className={'enrollmentForm-dropdown'}
                        onChange={(e) => handleCourseDropdownChange(e.target.value, setFieldValue)}
                        name={'courses.courseId'}
                        placeholder={'Select course'}
                      />
                      <ErrorMessage name='courses.courseId' component='div' className='error-msg' />
                    </div>

                    <div className='enrollmentForm-input'>
                      <label htmlFor=''>
                        Branch Selection<span className='required-symbol'>*</span>
                      </label>
                      <PageDropdown
                        options={branchList}
                        selectedValue={values?.courses?.branchId}
                        className={'enrollmentForm-dropdown'}
                        onChange={(e) =>
                          handleBranchDropdownChange(e.target.value, values.courses.courseId, setFieldValue)
                        }
                        name={'courses.branchId'}
                        placeholder={'Select branch'}
                      />
                      <ErrorMessage name='courses.branchId' component='div' className='error-msg' />
                    </div>

                    <div className='enrollmentForm-input'>
                      <label htmlFor=''>
                        Batch<span className='required-symbol'>*</span>
                      </label>
                      <PageDropdown
                        options={generateDropdownOptions(batches, 'batchNo', 'batchId')}
                        selectedValue={values?.courses?.batchId}
                        className={'enrollmentForm-dropdown'}
                        onChange={(e) =>
                          handleBatchDropdownChange(
                            e.target.value,
                            values?.courses?.courseId,
                            values?.courses?.branchId,
                            setFieldValue,
                            values,
                          )
                        }
                        name={'courses.batchId'}
                        placeholder={'Select Batch'}
                      />
                      <ErrorMessage name='courses.batchId' component='div' className='error-msg' />
                    </div>

                    <NewInput
                      label='Student Code'
                      placeholder='Enter student code'
                      name='studentCode'
                      width={'32%'}
                      required={true}
                      onInput={handleInputStringWithNum}
                    />

                    <NewInput
                      label='Course Fees'
                      placeholder='Course Fees'
                      name={'courses.courseFees'}
                      width={'32%'}
                      type={'text'}
                      // required={true}
                      onInput={handleInput}
                      disabled={true}
                    />

                    <NewInput
                      label='Discount'
                      placeholder='Discount'
                      name={'courses.discount'}
                      width={'32%'}
                      // value={values.courses.discount}
                      type={'text'}
                      // required={true}
                      onInput={handleInput}
                      onChange={(e) => handleDiscountChange(e.target.value, setFieldValue, values)}
                    />

                    <NewInput
                      label='Total Fees'
                      placeholder='Total Fees'
                      name={'courses.totalFees'}
                      width={'32%'}
                      type={'text'}
                      // required={true}
                      onInput={handleInput}
                      disabled={true}
                    />
                  </div>
                </div>
                {values?.courses?.batchId && (
                  <>
                    <div className='enrollmentForm'>
                      <div className='enrollmentForm-inner-header'>
                        <h1>{UI_CONSTANT.ENROLLMENT.FEES_STRUCTURE}</h1>
                        <p>{UI_CONSTANT.ENROLLMENT.FORM_DESCRIPTION}</p>
                      </div>

                      <div className='separatorLine'></div>

                      <div
                        role='group'
                        className='enrollment-drawer-input-radio-options flex align-center'
                        aria-labelledby='title-radio-group'
                      >
                        <label className='enrollment-drawer-input-radio-option-label flex align-center'>
                          <Field
                            type='radio'
                            name={'courses.feesStructure'}
                            value='oneTime'
                            className='custom-radio'
                            onChange={(e) => handleOneShotRadioChange(setFieldValue, e.target.value, values)}
                            // onChange={(values) => setFieldValue('feesStructure', "oneShot")}
                            checked={values?.courses?.feesStructure === 'oneTime'}
                            disabled={dayjs().diff(dayjs(initialValues.enrollmentDate), 'month') >= 1}
                          />
                          One Shot
                        </label>
                        <label className='enrollment-drawer-input-radio-option-label flex align-center'>
                          <Field
                            type='radio'
                            name='courses.feesStructure'
                            value='installment'
                            className='custom-radio'
                            onChange={(e) => handleInstallmentRadioChange(setFieldValue, e.target.value, values)}
                            // onChange={(e) => setFieldValue('courses.feesStructure', e.target.value)}
                            checked={values?.courses?.feesStructure === 'installment'}
                            disabled={dayjs().diff(dayjs(initialValues.enrollmentDate), 'month') >= 1}
                          />
                          Installment
                        </label>
                      </div>

                      <div className='enrollmentForm-input-fields'>
                        <NewInput
                          label='Registration'
                          placeholder='Registration Amount'
                          name='courses.registrationAmount'
                          width={'32%'}
                          type={'text'}
                          required={true}
                          onInput={handleInput}
                          onChange={(e) => handleRegistrationAmountChange(e.target.value, setFieldValue, values)}
                          disabled={feesDetails?.registrationDetails?.reg_payment_on}
                        />
                        <Calendar
                          value={values?.courses?.registrationAmountDate}
                          onChange={(value) => handleRegistrationDateChange(value, setFieldValue, values)}
                          label='Date'
                          clearable={true}
                          readOnly={false}
                          name='courses.registrationAmountDate'
                          width='32%'
                          className='enrollment-disabled-field'
                          disabled={feesDetails?.registrationDetails?.reg_payment_on}
                        />
                        <div className='empty-space'></div>
                        <FieldArray name='paymentHistory'>
                          <>
                            {values?.courses?.feesStructure === 'oneTime' && (
                              <>
                                <NewInput
                                  label='One Shot Amount'
                                  placeholder='One Shot Amount'
                                  value={values?.paymentHistory?.length && values?.paymentHistory[0].amount}
                                  name={`paymentHistory[0].amount`}
                                  width={'32%'}
                                  type={'text'}
                                  onInput={handleInput}
                                  maxLength={10}
                                  disabled={values?.paymentHistory?.length && values?.paymentHistory[0]?.paymentOn}
                                />
                                <Calendar
                                  value={
                                    id && values?.paymentHistory?.length
                                      ? convertDateFormatCalendar(
                                        dayjs(values?.paymentHistory && values?.paymentHistory[0].date)
                                          .format('DD/MM/YYYY'),
                                      )
                                      : null
                                  }
                                  onChange={(values) =>
                                    setFieldValue(`paymentHistory[0].date`, convertDateFormatCalendar(values))
                                  }
                                  label='Date'
                                  name={`paymentHistory[0].date`}
                                  width='32%'
                                  className='enrollment-disabled-field'
                                  disabled={values?.paymentHistory?.length && values?.paymentHistory[0]?.paymentOn}
                                />
                                <div className='empty-space'></div>
                              </>
                            )}
                          </>
                        </FieldArray>
                        {values?.courses?.feesStructure === 'installment' && (
                          <FieldArray name='paymentHistory'>
                            {({ push, remove }) => (
                              <>
                                {values &&
                                  values?.paymentHistory?.map((value, index) => {
                                    return (
                                      <div className='enrollmentForm-input-fields' key={index}>
                                        <NewInput
                                          label={countObj[index + 1]}
                                          placeholder={countObj[index + 1]}
                                          value={values?.paymentHistory?.length && values?.paymentHistory[index].amount}
                                          name={`paymentHistory[${index}].amount`}
                                          width={'32%'}
                                          type={'text'}
                                          onInput={handleInput}
                                          disabled={values?.paymentHistory?.length && values?.paymentHistory[index]?.paymentOn}
                                        />
                                        <Calendar
                                          // onChange={(date) =>
                                          //   handleInstallmentChange(index, 'date', date ? date.format('DD/MM/YYYY') : '')
                                          //     }
                                          // value={values?.feesCollection?.collectionDate}
                                          value={values?.paymentHistory[index]?.date}
                                          onChange={(values) =>
                                            setFieldValue(
                                              `paymentHistory[${index}].date`,
                                              convertDateFormatCalendar(values),
                                            )
                                          }
                                          label='Date'
                                          name={`paymentHistory[${index}].date`}
                                          width='32%'
                                          className='enrollment-disabled-field'
                                          disabled={values?.paymentHistory?.length && values?.paymentHistory[index]?.paymentOn}
                                        />
                                        {index !== 0 && (
                                          <div
                                            className='delete-mag-div'
                                            onClick={() => {
                                              handleDeleteInstallment(remove, index, values, setFieldValue)
                                            }}
                                          >
                                            <img src={deleteIcon} alt='deleteIcon' />
                                          </div>
                                        )}
                                      </div>
                                    )
                                  })}
                                <div className='addCompany-btn-div'>
                                  <Button
                                    type='button'
                                    customClassName={'addCompany-btn-div'}
                                    onClick={() => { // validate the installments' amount to not exceed the total fees.
                                      const allTransactions = Number(values.courses.registrationAmount) + values.paymentHistory.reduce((acc, i) => acc + (Number(i.amount) || 0), 0);
                                      const pendingFee = Number(values.courses.totalFees) - Number(allTransactions);

                                      if (pendingFee <= 0) {
                                        toast.error(`Installments exceed the total payable fees of ${Number(values.courses.totalFees)}.`);
                                        return;
                                      }

                                      push({
                                        amount: null,
                                        date: null,
                                      });
                                    }}
                                  >
                                    <u>Add Installment</u>
                                  </Button>
                                  <ToastContainer />
                                </div>
                              </>
                            )}
                          </FieldArray>
                        )}
                      </div>
                    </div>

                    <div className='enrollmentForm'>
                      <div className='enrollmentForm-inner-header'>
                        <h1>{UI_CONSTANT.ENROLLMENT.FEES_COLLECTION}</h1>
                        <p>{UI_CONSTANT.ENROLLMENT.FORM_DESCRIPTION}</p>
                      </div>

                      <div className='separatorLine'></div>
                      <div className='enrollmentForm-input-fields'>
                        <div className='enrollmentForm-input-method'>
                          <label htmlFor=''>Payment Method {!id ? <span className='required-symbol'>*</span> : <></>}</label>
                          <PageDropdown
                            options={values?.courses?.feesStructure === 'installment' ? [
                              { label: 'Registration', value: 'registration' },
                              ...(Array.isArray(values?.paymentHistory) ? values.paymentHistory.map((e, index) => ({
                                label: countObj[index + 1],
                                value: `${index + 1}`,
                              })) : []),
                            ] : [
                              { label: 'Registration', value: 'registration' },
                              { label: 'One Shot', value: 'Full payment' },
                            ]}
                            selectedValue={values?.feesCollection?.paymentMethod || ''}
                            className={'enrollmentForm-dropdown'}
                            onChange={(e) => handlePaymentMethod(e, setFieldValue, values)}
                            name={'feesCollection.paymentMethod'}
                            placeholder={'Select Payment Method'}
                          />

                          <ErrorMessage name='feesCollection.paymentMethod' component='div' className='error-msg' />
                        </div>
                        <Calendar
                          label='Collection Date'
                          placeholder='Enter date'
                          name='feesCollection.collectionDate'
                          width='23%'
                          required={!id ? true : false}
                          value={values?.feesCollection?.collectionDate}
                          onChange={(values) =>
                            setFieldValue('feesCollection.collectionDate', convertDateFormatCalendar(values))
                          }
                        />

                        <NewInput
                          label='Paid Amount'
                          placeholder='Paid amount'
                          name='feesCollection.paidAmount'
                          width={'23%'}
                          type={'text'}
                          value={values?.feesCollection?.paidAmount}
                          // onChange={(e) => setFieldValue('feesCollection?.paidAmount', e.target.values)}
                          onChange={handleChange}
                          onInput={handleInput}
                          maxLength={10}
                          required={!id ? true : false}
                          disabled={true}
                        />


                        <div className='enrollmentForm-input-method'>
                          <label htmlFor=''>Payment Mode{!id ? <span className='required-symbol'>*</span> : <></>}</label>
                          <PageDropdown
                            options={paymentMode}
                            selectedValue={values?.feesCollection?.paymentMode}
                            className={'enrollmentForm-dropdown'}
                            onChange={handleChange}
                            name={'feesCollection.paymentMode'}
                            placeholder={'Select Payment Mode'}
                          />
                          <ErrorMessage name='feesCollection.paymentMode' component='div' className='error-msg' />
                        </div>

                        <NewInput
                          label='Payment Remarks'
                          placeholder='Enter remarks'
                          value={values?.feesCollection?.paymentRemarks}
                          name={'feesCollection.paymentRemarks'}
                          width={'98.8%'}
                        // onInput={handleInputString}
                        />
                      </div>
                    </div>
                  </>
                )}
              </Form>
            )}
          </Formik>
        </div>
      )}
    </>
  )
}
export default EnrollmentForm
